import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';
import { CouponService } from 'src/app/services/coupon.service';
import { exhaustMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {  of, Subscription } from 'rxjs';
import { OtpService } from 'src/app/services/checkout-services/-otp.service';
import { Utils } from 'src/app/Utils';
import { ExternalRouterService } from 'src/app/services/external-router.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { SuccessfulComponent } from 'src/app/components/successful/successful.component';



@Component({
  selector: 'app-claim-reward-sheet',
  templateUrl: './claim-reward-sheet.component.html',
  styleUrls: ['./claim-reward-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ClaimRewardSheetComponent implements OnInit {
  isProductDetailPage:boolean = false;
  fg:FormGroup = this.fb.group({
      phoneNumber : new FormControl('', [Validators.pattern("^[0-9]{10}$"), Validators.required, Validators.minLength(10), Validators.maxLength(10)])
      
    });
    surpriseCoupon = null;
    skipOtp = environment.lead.skipOtp;
    couponRequest = {
      name: 'NOT_AVAILABLE',
      email: 'NOT_AVAILABLE',
      contactNumber: null,
      description: 'SALES', 
      relatedTo: 'SALES',
      title: 'SALES',
      source: null,
      landingPage: null,
      campaign:this._cookie.get('_campaign')
    }
  url: any;

  constructor(private bottomSheetRef: MatBottomSheetRef<ClaimRewardSheetComponent>,
    private bottomSheet: MatBottomSheet,
    private router: Router,
    private fb:FormBuilder,private matIconRegistry:MatIconRegistry, 
    private _cookie: CookieService,
    private couponService: CouponService ,
    private otpService: OtpService,
    private activatedRoute:ActivatedRoute,
    private externalRouter:ExternalRouterService,
  ) { }

  ngOnInit() {
    this.isProductDetailPage = this.router.url.startsWith("/gps-tracking-devices");
    this.campaign();
  }

  disable:boolean = false;
  otpInputEvent(){
    if(this.fg.valid){
      
      this.createCoupon();
    }
  }
  createCoupon(){
      
      if(this.fg.valid){
        this.disable =true;
        let newCoupon = this.newCouponInstance()
        this.couponService.createCoupon(newCoupon,  this._cookie.get('Authorization')).pipe(
          exhaustMap((x)=>{
            if(x.body){
              this.surpriseCoupon = x.body.coupon;
            } 
            if(this.skipOtp){
              return of(true);
            }
            return  this.otpService.sendOtp(this.fg.value.phoneNumber);
          })
        ).pipe(tap((x)=>{
          if(this.skipOtp){
            this.verifiedSuccessfully()
          }
         else{
            this.otpInput()
          }
        })).subscribe(x=> {
          this.disable = false;
          console.log("successfully send otp or created coupon")
        },err=> {
          this.disable = false;
        });
      }
      
    }

 newCouponInstance(){
    
    let coupon = {
      name: 'NOT_AVAILABLE',
      email: null,
      contactNumber: this.fg.value.phoneNumber,
      description: 'SALES', 
      relatedTo: 'SALES',
      title: 'Stand A Chance',
      source: Utils.getSource(this.url[0]),
      referrer: Utils.getReferer(),
      product: Utils.newProduct(this.router.url),
      utmMedium:Utils.getMedium(this.url[0]),
      utmCampaign: Utils.getLink(this.url[0]),
      landingPage:Utils.getLandingPage(this.url[0]),
      sourcePage: Utils.getSourcePage(this.router.url),
      element: Utils.ELEMENT.standAChance,
      campaign: this._cookie.get('_campaign')
    }
    return coupon;
  }

  campaign(){
    const campaign:string=this.activatedRoute.snapshot.queryParams.campaign
    this.url=this.externalRouter.getUrl();
    if(!!campaign){
      if(!this._cookie.check('_campaign') ){
        this._cookie.set('_campaign',campaign);
      }
    }
  }
otpInput(){
    // this.portalBridgeService.destroyRewardInputRef();
    // const injector = Injector.create({
    //   providers: [{ provide: CONTEXT_TOKEN, useValue: {phoneNumber: this.fg.value.phoneNumber, surprisedCoupon: this.surpriseCoupon  }}]
    // });
    // this.otpVerificationRef = new ComponentPortal<OtpVerificationComponent>(OtpVerificationComponent,null,injector);
    // this.portalBridgeService.setPortal(this.otpVerificationRef);
  }

verifiedSuccessfully(){
    // this.portalBridgeService.destroyRewardInputRef();
    // const injector = Injector.create({
    //   providers: [{ provide: CONTEXT_TOKEN, useValue: {phoneNumber: this.fg.value.phoneNumber, surprisedCoupon: this.surpriseCoupon}}]
    // });
    // let portal = new ComponentPortal<CongratulationComponent>(CongratulationComponent,null, injector);
   
    // this.portalBridgeService.setPortal(portal);
    this.bottomSheet.open(SuccessfulComponent);
    // alert('Congratulations! Coupon created successfully.');
    console.log('hello')
  }

  closeSheet(): void {
    this.bottomSheetRef.dismiss();
  }
}
